import jsPDF from "jspdf";
import { errorToastify } from "../../../Components/Common/Toaster";

export const EstimatedBill = (
  orderProducts,
  customerName,
  personalDetails,
  togGstModal,
  goldRate,
  silverRate
) => {
  if (!goldRate) {
    errorToastify("Please enter the gold rate.");
    return;
  }

  const calculteAddedVal = (order) => {
    let amount = parseInt(order.amount);
    let quantity = order.quantity;
    let mc = parseInt(order.mc);
    let goldPrice = parseInt(goldRate);
    let gram = parseFloat(order.gram);

    let basePrice = amount / 1.03;
    let basePriceGST = basePrice.toFixed(2) * 0.03;

    let total = basePriceGST + gram * goldPrice + mc;
    let totalMinusFromInitialAmt = total - amount;
    let v_added = totalMinusFromInitialAmt / goldPrice;

    return Math.abs(v_added).toFixed(3);
  };

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();

  // Document title and header
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.setTextColor("red");
  doc.text("TN Tech JEWELLERS", pageWidth / 2, 10, {
    align: "center",
  });
  doc.setTextColor("black");
  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  doc.text(
    "XXXXXXXXXXXXXXXXXXXXX",
    pageWidth / 2,
    15,
    {
      align: "center",
    }
  );
  doc.text("Ramanathapuram-623501", pageWidth / 2, 20, { align: "center" });
  doc.text("Phone: 9994522709", pageWidth / 2, 25, { align: "center" });

  let customerPlace = orderProducts[0].place;
  let customerAddress = orderProducts[0].address;
  let customerGST = orderProducts[0].gst_details;
  let customerPhoneNumber = orderProducts[0].phone_number;

  // Customer details section variables
  let startY = 35;

  // Customer details
  doc.setFont("helvetica", "bold");
  doc.text("Customer Name & Address: ", 10, startY);
  doc.setFont("helvetica", "normal");
  doc.text(`${String(customerName)}`, 10, startY + 5);
  doc.text(customerAddress, 10, startY + 10);
  doc.text(customerPlace, 10, startY + 15);
  doc.text(customerPhoneNumber, 10, startY + 20);
  doc.setFont("helvetica", "bold");

  // Rates and Bill info
  doc.text(`Gold Rate: ${String(goldRate)}`, 140, startY);
  doc.text(`Silver Rate: ${String(silverRate)}`, 140, startY + 5);
  doc.text(`Bill No: ${"634"}`, 140, startY + 10);
  doc.text(`Date: ${new Date().toLocaleDateString()}`, 140, startY + 15);

  startY += 35;

  // Table header
  doc.line(10, startY - 7, pageWidth - 10, startY - 7);
  doc.setFont("helvetica", "bold");
  doc.text("SL.No", 10, startY);
  doc.text("P.Name", 30, startY);
  doc.text("HUID", 60, startY);
  doc.text("Qty", 90, startY);
  doc.text("Grams", 120, startY);
  doc.text("MC", 150, startY);
  doc.text("V.Added", 170, startY);
  doc.text("Amt", 190, startY);
  doc.line(10, startY + 5, pageWidth - 10, startY + 5);

  // Initialize totals
  let totalAmount = 0;
  let totalGrams = 0;
  let sgst = 0;
  let cgst = 0;

  // Table Body
  orderProducts.forEach((order, index) => {
    startY += 13;
    doc.setFont("helvetica", "normal");
    doc.text(String(index + 1), 10, startY);
    doc.text(String(order.product_type_name || ""), 30, startY);
    doc.text(String(order.huid || ""), 60, startY);
    doc.text(String(order.quantity || "0"), 90, startY);
    doc.text(String(order.gram || "0"), 120, startY);
    doc.text(String(order.mc || "0"), 150, startY);
    doc.text(String(calculteAddedVal(order) || "0"), 170, startY);
    doc.text(String(order.amount || "0"), 190, startY);

    totalAmount += parseFloat(order.amount || 0);
    totalGrams += parseFloat(order.gram || 0);
  });

  // Display totals
  startY += 10;
  doc.setFont("helvetica", "bold");
  doc.text(`${totalGrams.toFixed(2)}`, 130, startY);
  doc.text(`Total: ${totalAmount.toFixed(2)}`, 155, startY);

  doc.setFont("helvetica", "normal");
  // doc.text("GST Details Including SGST And CGST", 10, startY + 30);

  startY += 5;
  doc.line(10, startY, pageWidth - 10, startY); // Line under header

  doc.setFont("helvetica", "bold");
  doc.text(`Mode Of Payment:`, 10, startY + 10);
  doc.text("__________________________", 10, startY + 20);

  /** Gst Calc end  */

  // Footer with bank details and signatures
  startY += 40;
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text("Declaration:", 10, startY);
  doc.setFont("helvetica", "normal");
  doc.text(
    "We declare that this invoice shows the actual price of the goods",
    10,
    startY + 5
  );
  doc.text(
    "described and that all particulars are true and correct",
    10,
    startY + 10
  );
  doc.setFont("helvetica", "bold");
  doc.text("Remarks:", 10, startY + 20);
  doc.setFont("helvetica", "normal");
  doc.text("Including VA and Hallmark charges", 30, startY + 20);
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text("Bank Details:", 140, startY);
  doc.setFont("helvetica", "normal");
  doc.text(`Bank Name: ${personalDetails.bank}`, 140, startY + 5);
  doc.text(`Account Number: ${personalDetails.acc_no}`, 140, startY + 10);
  doc.text(`IFSC Code: ${personalDetails.ifsc_code}`, 140, startY + 15);
  doc.text(`Branch: ${personalDetails.branch}`, 140, startY + 20);

  startY += 30;
  doc.setFont("helvetica", "bold");
  doc.text("Customer Signature:", 10, startY);
  doc.setFont("helvetica", "normal");
  doc.text("__________________________", 10, startY + 10);
  doc.setFont("helvetica", "bold");
  doc.text("Authorized Signature: ", 140, startY);
  doc.setFont("helvetica", "normal");
  doc.text("__________________________", 140, startY + 10);

  doc.setFont("helvetica", "bold");
  doc.text(
    "SUBJECT TO RAMANATHAPURAM JURISDICTION",
    pageWidth / 2,
    startY + 40,
    {
      align: "center",
    }
  );
  doc.setFont("helvetica", "normal");
  doc.text("This Is Computer Generated Invoice", pageWidth / 2, startY + 45, {
    align: "center",
  });

  // Save the PDF
  doc.save(`Estimate_Report_${customerName}.pdf`);

  // Close GST Modal
  togGstModal();
};
